import { combineEpics } from "redux-observable";
import { epicCoopXpRanking } from "./epicCoopXpRanking";
import { epicCoopXpRankingByName } from "./epicCoopXpRankingByName";
import { epicCoopXpRankingByPosition } from "./epicCoopXpRankingByPosition";
import { epicPlayerXpRanking } from "./epicPlayerXpRanking";
import { epicPlayerXpRankingByName } from "./epicPlayerXpRankingByName";
import { epicPlayerXpRankingByPosition } from "./epicPlayerXpRankingByPosition";
export var epicPlayerRanking = combineEpics(epicPlayerXpRanking, epicPlayerXpRankingByName, epicPlayerXpRankingByPosition, epicCoopXpRanking, epicCoopXpRankingByName, epicCoopXpRankingByPosition);



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicPlayerRanking.ts
// module id = 2116
// module chunks = 3